/**
 * 알림 발송 인자 변환 — `NotificationContext.createNotification` 입력을 RPC `send_notification` 인자로.
 *
 * 2026-09-05 (QA 1차 대장 #43 후속): 클라이언트가 `notification` 테이블에 직접 insert 하던 것을
 * SECURITY DEFINER RPC 로 옮겼다. INSERT 정책은 어드민 전용(마이그레이션 20260905000002)이라
 * 비어드민 화면(검수 신청·완료·브랜드 문의)은 이 RPC 를 지나야만 알림이 들어간다.
 * 서버가 type 별로 발신자·수신자 관계를 검사하고, 비어드민의 actor_name 은 서버가 정한다.
 *
 * 입력 키 이름(recipientEmail·category·type·title·body·metadata·link·actorName)은 기존 호출처 9곳이
 * 그대로 쓰므로 바꾸지 않는다.
 */
export const SEND_NOTIFICATION_RPC = "send_notification";

export function buildSendNotificationArgs({
  recipientEmail,
  category,
  type,
  title,
  body,
  metadata,
  link,
  actorName,
} = {}) {
  return {
    p_recipient_email: recipientEmail ?? null,
    p_category: category ?? null,
    p_type: type ?? null,
    p_title: title ?? null,
    p_body: body ?? null,
    p_link: link ?? null,
    p_metadata: metadata && typeof metadata === "object" ? metadata : {},
    p_actor_name: actorName ?? null,
  };
}
